import { Component, OnInit, PLATFORM_ID, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, NavigationEnd, RouterOutlet } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { SnackbarHostComponent } from './shared/snackbar/snackbar-host.component';


//Facebook pixel tag function
declare let fbq: (...args: unknown[]) => void;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet, SnackbarHostComponent]
})
export class AppComponent implements OnInit {
  router = inject(Router);
  private platformId = inject(PLATFORM_ID);


  title = 'intermedium-web-app';

  private destroyRef = inject(DestroyRef);

  ngOnInit() {
    this.setupFacebookAnalyticsForRoutes();
  }

  setupFacebookAnalyticsForRoutes() {

    if (isPlatformBrowser(this.platformId)) {

      this.router.events.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(event => {
        if (event instanceof NavigationEnd && isPlatformBrowser(this.platformId)) {
          //Generate facebook event
          fbq('track', 'PageView');
        }
      });

    }
  }

}
